import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Car, CalendarClock, Handshake, Users, Bot } from "lucide-react";
import api from "../lib/api";
import { formatDate } from "../lib/format";

const Stat = ({ label, value, sub, testId }) => (
  <div className="bg-white border hairline p-6 rounded-sm" data-testid={testId}>
    <div className="overline text-[#242424]/60">{label}</div>
    <div className="mt-2 font-display text-3xl font-semibold text-[#111111]">{value ?? "—"}</div>
    {sub && <div className="text-xs text-[#242424]/60 mt-1">{sub}</div>}
  </div>
);

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setData(r.data)); }, []);
  const t = data?.totals || {};

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div>
        <div className="overline text-[#7A1519]">Overview</div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tight font-semibold text-[#111111]">Dashboard</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <Stat label="Total Vehicles" value={t.vehicles} testId="stat-total" />
        <Stat label="Available" value={t.available} testId="stat-available" />
        <Stat label="Reserved" value={t.reserved} testId="stat-reserved" />
        <Stat label="Sold" value={t.sold} testId="stat-sold" />
        <Stat label="Coming Soon" value={t.coming_soon} testId="stat-coming" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Link to="/admin/test-drives" className="bg-white border hairline p-6 rounded-sm hover:border-[#7A1519] transition-colors" data-testid="stat-td">
          <CalendarClock size={18} className="text-[#7A1519]" />
          <div className="mt-4 overline text-[#242424]/60">New Test Drives</div>
          <div className="mt-1 font-display text-3xl font-semibold">{t.new_test_drives ?? 0}</div>
        </Link>
        <Link to="/admin/sell-leads" className="bg-white border hairline p-6 rounded-sm hover:border-[#7A1519] transition-colors" data-testid="stat-sell">
          <Handshake size={18} className="text-[#7A1519]" />
          <div className="mt-4 overline text-[#242424]/60">Sell-Your-Car Leads</div>
          <div className="mt-1 font-display text-3xl font-semibold">{t.new_sell_leads ?? 0}</div>
        </Link>
        <Link to="/admin/leads" className="bg-white border hairline p-6 rounded-sm hover:border-[#7A1519] transition-colors" data-testid="stat-contact">
          <Users size={18} className="text-[#7A1519]" />
          <div className="mt-4 overline text-[#242424]/60">Customer Enquiries</div>
          <div className="mt-1 font-display text-3xl font-semibold">{t.new_contact_leads ?? 0}</div>
        </Link>
        <Link to="/admin/leads?source=ai_assistant" className="bg-white border hairline p-6 rounded-sm hover:border-[#7A1519] transition-colors" data-testid="stat-ai">
          <Bot size={18} className="text-[#7A1519]" />
          <div className="mt-4 overline text-[#242424]/60">AI Assistant Leads</div>
          <div className="mt-1 font-display text-3xl font-semibold">{t.ai_leads ?? 0}</div>
        </Link>
      </div>

      <div className="bg-white border hairline rounded-sm">
        <div className="px-6 py-4 border-b hairline flex items-center justify-between">
          <div className="font-display font-semibold">Recent activity</div>
        </div>
        <div className="divide-y hairline">
          {(data?.recent_activity || []).length === 0 && <div className="p-6 text-sm text-[#242424]/60">No activity yet.</div>}
          {(data?.recent_activity || []).map((a, i) => (
            <div key={i} className="px-6 py-4 flex items-center justify-between gap-4 text-sm" data-testid={`activity-${i}`}>
              <div>
                <div className="font-medium text-[#111111]">{a.name}</div>
                <div className="text-xs text-[#242424]/70">{a.vehicle_summary}</div>
              </div>
              <div className="text-right">
                <div className="text-xs uppercase tracking-[0.18em] text-[#7A1519] font-semibold">{a.type.replace("_", " ")}</div>
                <div className="text-xs text-[#242424]/50">{formatDate(a.created_at)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
